import Default from 'apps/company/layouts/Default';
import * as React from 'react';
import { Navigate } from 'react-router-dom';
import RouteName from 'config/routes';
import { useSelector } from 'react-redux';
import { useGetCompanyUserQuery } from 'services/authCompany';
import { useGetCampaignNotificationQuery } from 'services/company/systemSetting';
import { useGetLatestSystemNotificationQuery } from 'services/company/notification';
import companyUserSelector from 'selectors/companyUserSelector';
import notFoundSelector from 'selectors/notFoundSelector';
import campaignNotificationSelector from 'selectors/campaignNotificationSelector';
import latestSystemNotificationSelector from 'selectors/latestSystemNotificationSelector';
import { Loading } from 'components';

const ProtectedRoutes = () => {
  const { isError, refetch, isFetching } = useGetCompanyUserQuery();
  const companyUser = useSelector(companyUserSelector);

  const { isError: isErrorCampaignNotification } = useGetCampaignNotificationQuery();
  useSelector(campaignNotificationSelector);

  const { isError: isErrorLatestSystemNotification } = useGetLatestSystemNotificationQuery();
  useSelector(latestSystemNotificationSelector);

  const notFound = useSelector(notFoundSelector);

  React.useEffect(() => {
    if (!isFetching && !companyUser) {
      refetch();
    }
  }, [isFetching, refetch, companyUser]);

  if (notFound) {
    return <Navigate to={RouteName.notFound} />
  }

  return isFetching ? <Loading isLoading={true} /> : !isError && !isErrorCampaignNotification && !isErrorLatestSystemNotification && companyUser ? (
    <Default />
  ) : (
    <Navigate to={RouteName.loginCompany} />
  );
};

export default ProtectedRoutes;
